import { createWithEqualityFn } from "zustand/traditional";
import { subscribeWithSelector } from "zustand/middleware";
import { createPathnameSlice } from "./slices/pathnameSlice";
import { createSegmentsSlice } from "./slices/segmentsSlice";
import { createParamsSlice } from "./slices/paramsSlice";
import type { NavigationState } from "./types";

export const useNavigationStore = createWithEqualityFn<NavigationState>()(
  subscribeWithSelector((...a) => ({
    ...createPathnameSlice(...a),
    ...createSegmentsSlice(...a),
    ...createParamsSlice(...a),
  })),
);
